import { ApiModule } from "@api/src/ApiModule"

export class User extends ApiModule {
  constructor(props) {
    super(props)

    this.roles = this.getGlobal("tenant.user.roles")
    this.permissions = this.getGlobal("tenant.user.permissions")
  }

  get isReferrer() {
    return Ambition.hasRoleOrPermission('referrer')
  }

  get isNonAcrReferrer() {
    return Ambition.hasRoleOrPermission('referrer') && !Ambition.hasRoleOrPermission('show application tab')
  }

  get isAcrReferrer() {
    return Ambition.hasRoleOrPermission('referrer') && Ambition.hasRoleOrPermission('show application tab')
  }
}
